module.exports = __webpack_public_path__ + "static/media/atharva.bdc66621.jpeg";